import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'tcm-plug',
    templateUrl: './plug.component.html',
    standalone: false
})
export class PlugComponent {
}
